import { getWidgetViews } from './getWidgetViews';

export const widgets = {
  getWidgetViews,
};
